import { Callback, ObservableStore } from "../core/obvservable";
import { isoLangs } from "../../../../../global/dist/misc/isoLangs";
import { computed } from "mobx";

// ILangItem
export interface ILangItem {
	label: string;
	value: string;
}

/**
 * Languages
 */
export class UserLanguagesStore<T extends string, D extends Record<T, string>> {
	// Max items
	public static readonly MAX_ITEMS = 5;

	// Max items
	protected __maxItems: number;

	// Items
	protected __items: ILangItem[];

	/**
	 * Class constructor
	 * @param store
	 */
	public constructor(protected readonly store: ObservableStore<D>, protected readonly attr: T, maxItems?: number) {
		this.__maxItems = maxItems ?? UserLanguagesStore.MAX_ITEMS;

		this.__items = Object.keys(isoLangs).map((code) => ({
			label: isoLangs[code].name,
			value: code,
		}));
	}

	// Items
	public get items() {
		return this.__items;
	}

	/**
	 * Value
	 */
	public get value(): string {
		return this.store.data[this.attr];
	}

	/**
	 * Clear
	 * @param cb
	 */
	public clear(cb?: Callback) {
		this.store.set(this.attr, null, cb);
	}

	/**
	 * Languages
	 */
	@computed public get assigned() {
		return this.value ? this.value.split(",") : [];
	}

	/**
	 * Selected lang.
	 */
	@computed public get selectedLanguages() {
		const { assigned } = this;
		if (assigned.length === 0) return [];

		return this.assigned.map((code) => this.items.find((item) => item.value === code)).filter((item) => !!item);
	}

	/*
	 * Toggle lang
	 * @param lang
	 */
	public toggleLanguage(lang: string, cb?: Callback) {
		const languages = this.assigned.slice(0);
		const i = languages.indexOf(lang);

		if (i > -1) {
			languages.splice(i, 1);
		} else {
			languages.push(lang);
		}

		if (languages.length > this.__maxItems) languages.shift();

		const patch: Partial<Record<T, string>> = {};
		patch[this.attr] = languages.length > 0 ? languages.join(",") : null;

		console.log(this.constructor.name, "update lang", patch);

		this.store.mset(patch as any, cb);
	}
}
